import type React from "react";
import type { ReactNode } from "react";

import { Text } from "@/components/ui/text";

export function TestRunCard({
  children,
  title,
}: {
  title?: React.ReactNode;
  children: ReactNode;
}) {
  return (
    <div>
      {title && (
        <Text size="4" className="block pb-5">
          {title}
        </Text>
      )}
      {children}
    </div>
  );
}
